import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import api from "@/lib/api";
import { WindReveal } from "@/components/Cinematic";

export default function Work() {
  const [projects, setProjects] = useState([]);
  const [services, setServices] = useState([]);

  useEffect(() => {
    document.title = "Work — seedesign";
    api.get("/projects").then((r) => setProjects(r.data)).catch(() => {});
    api.get("/services").then((r) => setServices(r.data)).catch(() => {});
  }, []);

  return (
    <div className="pt-28 pb-24">
      <div className="mx-auto max-w-[1400px] px-6 lg:px-10">
        <p className="text-sm uppercase tracking-[0.2em] text-[#66371B] mb-4">Selected Work</p>
        <h1 className="font-serif text-5xl sm:text-6xl lg:text-7xl tracking-tight text-[#3F3F2C] max-w-4xl">
          <WindReveal text="Strategy, craft and commerce, brought to life." />
        </h1>

        {/* Static disciplines — what the studio offers (not filters) */}
        <div className="mt-12">
          <p className="text-xs uppercase tracking-[0.2em] text-[#81754B] mb-4">What we do</p>
          <p className="font-serif text-2xl lg:text-3xl text-[#3F3F2C] leading-relaxed max-w-4xl" data-testid="work-disciplines">
            {services.map((s, i) => (
              <span key={s.slug} data-testid={`discipline-${s.slug}`}>
                {s.title}
                {i < services.length - 1 && <span className="text-[#81754B] mx-3" aria-hidden="true">·</span>}
              </span>
            ))}
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="work-grid">
          {projects.map((p, i) => (
            <motion.div
              key={p.slug}
              initial={{ opacity: 0, scale: 0.94 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.55, delay: (i % 3) * 0.05, ease: [0.16, 1, 0.3, 1] }}>
              <Link to={`/work/${p.slug}`} data-testid={`work-card-${p.slug}`}
                className="group block overflow-hidden rounded-sm bg-[#E3D8C1]">
                <div className="relative aspect-[4/3] overflow-hidden">
                  <img src={p.hero_image} alt={p.title} loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-[900ms] group-hover:scale-110" />
                  <div className="absolute inset-0 bg-[#3F3F2C]/0 group-hover:bg-[#3F3F2C]/20 transition-colors" />
                  <span className="absolute top-4 right-4 grid place-items-center h-10 w-10 rounded-full bg-[#F7F1E1]/90 text-[#3F3F2C] opacity-0 group-hover:opacity-100 transition-opacity">
                    <ArrowUpRight size={18} />
                  </span>
                </div>
                <div className="p-5">
                  <p className="text-xs uppercase tracking-[0.2em] text-[#81754B]">{p.industry}</p>
                  <h3 className="font-serif text-2xl text-[#3F3F2C] mt-1 group-hover:text-[#66371B] transition-colors">{p.title}</h3>
                  <p className="text-sm text-[#5C6B4A] mt-1">{p.subtitle}</p>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </div>
  );
}
